import { useQuery } from '@tanstack/react-query';
import { createFileRoute, redirect } from '@tanstack/react-router';

import { Skeleton } from '@mui/material';

import { claimQueries } from '@repo/api/claim/claims';
import { Activity } from '@repo/features/activity';

import { Route as ClaimRoute } from '~pages/_claims/claim.$claimId/_claim/index';

export const Route = createFileRoute('/_claims/claim/$claimId/_claim/activity')(
	{
		beforeLoad: ({ params, context }) => {
			if (!context.user?.permissions.includes('claim.activitylog.view')) {
				throw redirect({
					to: ClaimRoute.to,
					params,
				});
			}
		},
		component: function ActivityPage() {
			const { claimId } = Route.useParams();

			const { data: activity, isLoading } = useQuery(
				claimQueries.activity(claimId),
			);
			if (isLoading) return <Skeleton height={60} />;

			return <Activity activity={activity} />;
		},
		head: (ctx) => ctx.match.context.setTitle('Claim', 'Activity'),
	},
);
